import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../globals';
import {DialogService} from '../../../services/dialog.service';
import {MatDialog} from '@angular/material/dialog';
import {UntypedFormBuilder} from '@angular/forms';
import {ARService} from '../../ar/ar.service';
import {cfgARAccount, enumValidValueItem} from '../../ar/_models/ar.models';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {CfgARPaymentMethodModel} from '../../../models/accountsReceivable/cfg-ar-payment-method';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {PaymentMethodConfigurationService} from './payment-method-configuration.service';
import { ConfirmComponent } from '../../../dialog/confirm-dialog/confirm.component';
@Component({
    selector: 'app-payment-method-configuration',
    templateUrl: './payment-method-configuration.component.html',
    styleUrls: ['./payment-method-configuration.component.scss']
})
export class PaymentMethodConfigurationComponent implements OnInit {

    @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;

    paymentMethods: CfgARPaymentMethodModel[] = [];
    paymentCCSources: enumValidValueItem[] = [];
    paymentESources: enumValidValueItem[] = [];
    paymentESourcesMaster: enumValidValueItem[] = [];
    paymentTypes: enumValidValueItem[] = [];
    isLoading: boolean = false;
    clientList: TdoClientConfigurationModel[] = [];
    locationList: ClientLocationDataModel[] = [];
    selectedClient: TdoClientConfigurationModel;
    selectedLocation: ClientLocationDataModel;
    selectedPaymentMethod: CfgARPaymentMethodModel;
    selectedPaymentMethodRevert: CfgARPaymentMethodModel;
    listOfAccounts: cfgARAccount[] = [];
    isSaved: boolean = false;
    saveDisabled: boolean = true;
    isEditing: boolean = false;

    constructor(
        private snackBar: MatSnackBar,
        private globals: Globals,
        private dialogService: DialogService,
        private snackbar: MatSnackBar,
        private dialog: MatDialog,
        private paymentMethodConfigService: PaymentMethodConfigurationService,
        private fb: UntypedFormBuilder,
        private arService: ARService,
    ) { }

    ngOnInit(): void {

        // load payment enums
        this.loadPaymentEnumTypes();

        this.paymentMethodConfigService.getClients().subscribe(data => {
            this.clientList = data;
            const currentClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
            if (currentClient) {
                this.selectedClient = currentClient;
            } else {
                this.selectedClient = this.clientList[0];
            }
            this.onChangeClient(null);
        }, err => {
        });
    }

    loadPaymentEnumTypes() {
        const promises = [
            this.getEnumValidValueItemsByValidValueName('enumARPayementType'),
            this.getEnumValidValueItemsByValidValueName('enumARPayementEType'),
            this.getEnumValidValueItemsByValidValueName('enumARPayementCCType'),
            this.arService.getAllARAccounts().toPromise()
        ];

        this.isLoading = true;
        Promise.all(promises).then((results: any[]) => {

            this.paymentTypes = this.sortEnum(results[0]);
            this.paymentESources = this.sortEnum(results[1]);
            this.paymentCCSources = this.sortEnum(results[2]);
            this.listOfAccounts = results[3];

            this.isLoading = false;
        }, err => {
            this.createMessage('Something went wrong', 'Error');
            this.isLoading = false;
        });
    }

    onChangeClient(e): void {

        this.paymentMethodConfigService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
            this.locationList = ldata;
            this.selectedLocation = null;
            this.paymentMethods = []; // payment methods

            if (this.locationList.length > 0) {
                const currentLoc = this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID);
                if (currentLoc) {
                    this.selectedLocation = currentLoc;
                } else {
                    this.selectedLocation = this.locationList[0];
                }
                this.onChangeLoc('');
            }
            else {
                // no locations returned, clear and disable right side
                this.paymentMethods = [];
                this.locationList = [];
                this.selectedPaymentMethod = null;
                this.selectedPaymentMethodRevert = null;
            }
        }, err => {
        });
    }

    async onChangeLoc(e) {

        const promises: any[] = [
            this.paymentMethodConfigService.getPaymentMethodList(this.selectedLocation.LOCID.toString()).toPromise(),
        ];

        const results: any[] = await Promise.all(promises);
        this.paymentMethods = results[0];

        if (this.paymentMethods.length === 0) {
            // no payment methods returned
            this.paymentMethods = [];
        }
        else {
            this.selectedPaymentMethod = this.paymentMethods[0];
            this.setPaymentMethodDetails();
            this.isEditing = false;
            this.saveDisabled = true;
        }

        // update table
        this.tdoTable.dataSource = this.paymentMethods;
        this.tdoTable.updateData();
    }

    onEdit(event) {
        this.saveDisabled = false;
        this.isEditing = true;
    }

    onSave(event, showConfirmation: boolean = true) {

        // save processor
        this.isLoading = true;

        // save changes to db
        this.paymentMethodConfigService.savePaymentMethod(this.selectedPaymentMethod).subscribe(saved => {
            if (saved)
            {
                // save successful
                if (showConfirmation) {
                    this.createMessage('Payment method saved', 'Success');
                }

                // if new payment method
                const method = this.paymentMethods.filter(a => a.PaymentMethodID === saved.PaymentMethodID);
                if (method.length === 0)
                {
                    this.paymentMethods.push(saved);
                }

                this.tdoTable.dataSource = this.paymentMethods;
                this.tdoTable.updateData();
                this.isSaved = true;
                this.selectedPaymentMethod = saved;
                this.setSelectedPaymentMethodRevert();
                this.isLoading = false;
                this.isEditing = false;
            }
        }, err => {
            this.createMessage('Error saving payment method', 'Error');
            this.isLoading = false;
        });

        // reset saved vars
        this.isSaved = false;
    }

    onCancel(event) {
        this.saveDisabled = true;
        this.isEditing = false;

        // revert changes
        this.revertSelectedPaymentMethod();
    }

    onClearPaymentMethods(): void {

      // aljehandos code wrong !!!!

        // this.openConfirmationDialog(
        //     'Clear Payment Methods',
        //     'Are you sure you want to clear all payment methods for this location?'
        // ).then((result: boolean) => {
        //     if (!result) {
        //         return; // Exit if the user cancels the confirmation
        //     }
        //
        //     // Show a loading indicator
        //     this.isLoading = true;
        //
        //     // Call the backend service to clear payment methods
        //     this.paymentMethodConfigService.clearPaymentMethods(this.selectedLocation.LOCID.toString()).subscribe(
        //         () => {
        //             this.paymentMethods = []; // Clear the table data
        //             this.tdoTable.dataSource = this.paymentMethods; // Update the table data source
        //             this.tdoTable.updateData(); // Refresh the table view
        //             this.createMessage('All payment methods have been cleared successfully', 'Success');
        //             this.isLoading = false;
        //         },
        //         (err) => {
        //             this.createMessage('Error clearing payment methods. Please try again.', 'Error');
        //             this.isLoading = false;
        //         }
        //     );
        // });
    }

    openConfirmationDialog(title: string, message: string): Promise<boolean> {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '402px', // Adjust dialog size if needed
            data: {
                title,
                message,
                isShowCancel: true,
                isShowNo: false, // Optional, depending on your use case
            },
        });

        // Return a promise that resolves when the dialog is closed
        return dialogRef.afterClosed().toPromise();
    }

    onNewPaymentMethod(event) {
    // set empty by default
        this.selectedPaymentMethod = new CfgARPaymentMethodModel();
        this.selectedPaymentMethod.LOCID = this.selectedLocation.LOCID;
        this.setSelectedPaymentMethodRevert(); // might not want this here, possibly set revert after save

        this.saveDisabled = false;
        this.isEditing = true;
    }

    setPaymentMethodDetails() {
    // this should all be getting set in html view
        this.setSelectedPaymentMethodRevert();
    }

    createMessage(message, type) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    setSelectedPaymentMethodRevert() {
        if (!this.selectedPaymentMethodRevert) {
            this.selectedPaymentMethodRevert = new CfgARPaymentMethodModel();
        }
        this.selectedPaymentMethodRevert.PaymentMethodID = this.selectedPaymentMethod.PaymentMethodID;
        this.selectedPaymentMethodRevert.TDOCID = this.selectedPaymentMethod.TDOCID;
        this.selectedPaymentMethodRevert.LOCID = this.selectedPaymentMethod.LOCID;
        this.selectedPaymentMethodRevert.ItemOrder = this.selectedPaymentMethod.ItemOrder;
        this.selectedPaymentMethodRevert.Name = this.selectedPaymentMethod.Name;
        this.selectedPaymentMethodRevert.isActive = this.selectedPaymentMethod.isActive;
        this.selectedPaymentMethodRevert.enumARPayementCCTypeID = this.selectedPaymentMethod.enumARPayementCCTypeID;
        this.selectedPaymentMethodRevert.enumARPayementETypeID = this.selectedPaymentMethod.enumARPayementETypeID;
        this.selectedPaymentMethodRevert.enumARPayementTypeID = this.selectedPaymentMethod.enumARPayementTypeID;
        this.selectedPaymentMethodRevert.Description = this.selectedPaymentMethod.Description;
    }

    trackByFn(i: number, items: any) {
        return i; // returning the index itself for avoiding ngFor to change focus after ngModelChange
    }

    getEnumValidValueItemsByValidValueName(ValidValueName: string) {
        const promise = new Promise((resolve, reject) => {
            this.arService.getEnumValidValueItemsByValidValueName(ValidValueName)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    sortEnum(enumList: any[]) {
        return enumList.sort((a, b) => a.ItemOrder - b.ItemOrder);
    }

    onRowSelected($event: TdoTableSelectionEvent) {
        this.revertSelectedPaymentMethod();

        this.selectedPaymentMethod = $event.model;
        this.setPaymentMethodDetails();

        this.isEditing = false;
        this.saveDisabled = true;
    }

    revertSelectedPaymentMethod() {
        if (this.selectedPaymentMethod && this.selectedPaymentMethodRevert) {
            this.paymentMethods.forEach(a => {
                if (this.selectedPaymentMethod.PaymentMethodID === a.PaymentMethodID) {

                    this.selectedPaymentMethod.PaymentMethodID = this.selectedPaymentMethodRevert.PaymentMethodID;
                    this.selectedPaymentMethod.TDOCID = this.selectedPaymentMethodRevert.TDOCID;
                    this.selectedPaymentMethod.LOCID = this.selectedPaymentMethodRevert.LOCID;
                    this.selectedPaymentMethod.ItemOrder = this.selectedPaymentMethodRevert.ItemOrder;
                    this.selectedPaymentMethod.Name = this.selectedPaymentMethodRevert.Name;
                    this.selectedPaymentMethod.isActive = this.selectedPaymentMethodRevert.isActive;
                    this.selectedPaymentMethod.enumARPayementCCTypeID = this.selectedPaymentMethodRevert.enumARPayementCCTypeID;
                    this.selectedPaymentMethod.enumARPayementETypeID = this.selectedPaymentMethodRevert.enumARPayementETypeID;
                    this.selectedPaymentMethod.enumARPayementTypeID = this.selectedPaymentMethodRevert.enumARPayementTypeID;
                    this.selectedPaymentMethod.Description = this.selectedPaymentMethodRevert.Description;
                }
            });
        }
    }

  onClickClearType()  {
    this.selectedPaymentMethod.enumARPayementTypeID =  null;

  }
  onClickClearEType() {

    this.selectedPaymentMethod.enumARPayementETypeID =  null;
  }
  onClickClearCCType() {

    this.selectedPaymentMethod.enumARPayementCCTypeID= null;
  }
  onClickClearARAcc() {
    this.selectedPaymentMethod.ARAccountID= null;

  }

}
